const allElementsString = arr => {
  return arr.every(elem => typeof elem === 'string');
};

const allElementsNumbers = arr => {
  return arr.every(elem => typeof elem === 'number');
};

const formatArray = params => {
  if (params.length <= 0) {
    params = [];
  } else if (allElementsString(params) || allElementsNumbers(params)) {
    params = [...params];
  } else {
    params = params.map(val => val.id);
  }
  return params;
};

const generatePayloadForObject = item => {
  if (item.action_params.id) {
    item.action_params = [item.action_params.id];
  } else {
    item.action_params = [item.action_params];
  }
  return item.action_params;
};

const CUSTOM_ATTRIBUTE_ARRAY_ACTIONS = [
  'add_to_custom_attribute_list',
  'remove_from_custom_attribute_list',
  'update_custom_attribute',
];

const normalizeCustomAttributeActionParams = actionParams => {
  const normalizeValues = values => {
    if (Array.isArray(values)) {
      return values;
    }
    if (values != null && values !== '') {
      return [values];
    }
    return [];
  };
  if (!actionParams) return [];

  if (Array.isArray(actionParams)) {
    const first = actionParams[0] || {};
    const values = normalizeValues(first.values);

    return [
      {
        attribute_key: first.attribute_key,
        attribute_model: first.attribute_model || 'conversation_attribute',
        values,
      },
    ];
  }

  if (typeof actionParams === 'object') {
    const values = normalizeValues(actionParams.values);

    return [
      {
        attribute_key: actionParams.attribute_key,
        attribute_model:
          actionParams.attribute_model || 'conversation_attribute',
        values,
      },
    ];
  }

  return [];
};

const generatePayload = data => {
  const actions = JSON.parse(JSON.stringify(data));
  const payload = actions.map(item => {
    if (CUSTOM_ATTRIBUTE_ARRAY_ACTIONS.includes(item.action_name)) {
      item.action_params = normalizeCustomAttributeActionParams(
        item.action_params
      );
      return item;
    }

    if (Array.isArray(item.action_params)) {
      item.action_params = formatArray(item.action_params);
    } else if (typeof item.action_params === 'object') {
      item.action_params = generatePayloadForObject(item);
    } else if (!item.action_params) {
      item.action_params = [];
    } else {
      item.action_params = [item.action_params];
    }
    return item;
  });
  return payload;
};

export default generatePayload;
